import { formatValor } from '@common/utils'
import textos from '../assets/textos.json'
import * as styles from './Tooltip.module.scss'

export default function Tooltip({ nom, vots, selectedLayer, valorLayer, lang, noCsv }) {
	const tipusDades = textos[lang]?.tipusDades.find((dada) => dada.key === selectedLayer) ?? []

	return (
		<div className={styles.container}>
			<header>{nom}</header>
			<p>
				<span>
					<span className={styles.bullet} style={{ backgroundColor: '#005DAD' }}></span>
					{textos[lang]?.vots}
				</span>
				<span>{noCsv || vots == null ? '-' : `${formatValor(vots)}%`}</span>
			</p>
			{selectedLayer !== null && (
				<p>
					<span>
						<span className={styles.bullet}></span>
						{tipusDades?.nom || ''}
					</span>
					<span>
						{formatValor(valorLayer)}
						{tipusDades?.unitat}
					</span>

					{/* {dades.map((dada, index) => (
						<p
							key={index}
							style={{ order: tipusDades?.[index]?.mapa ? index : index + 100 }}
							data-nompa={!tipusDades?.[index]?.mapa}
						>
							<span>
								{tipusDades?.[index]?.mapa && <span className={styles.bullet}></span>}
								{tipusDades?.[index]?.nom}
							</span>
							<span>
								{formatValor(
									dada,
									tipusDades?.[index]?.key === 'renda' || tipusDades?.[index]?.key === 'poblacio'
										? 0
										: 2,
								)}
								{tipusDades?.[index]?.unitat}
							</span>
						</p>
					))} */}
				</p>
			)}
		</div>
	)
}
